document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".ms-slider").forEach(function (slider) {
    const track = slider.querySelector(".ms-slider-track");
    let slides = Array.from(track.children);
    const prev = slider.querySelector(".ms-slider-prev");
    const next = slider.querySelector(".ms-slider-next");

    const visibleSlides = parseFloat(
      [...slider.classList].find(c => c.startsWith("ms-slider--"))
        .replace("ms-slider--", "")
        .replace("-", ".")
    );

    // --- Clone slides ---
    const clonesBefore = [];
    const clonesAfter = [];
    // const cloneCount = Math.ceil(visibleSlides);

    // for (let i = 0; i < cloneCount; i++) {
    //   const firstClone = slides[i].cloneNode(true);
    //   const lastClone = slides[slides.length - 1 - i].cloneNode(true);
    //   clonesAfter.push(firstClone);
    //   clonesBefore.unshift(lastClone);
    // }
    // clonesBefore.forEach(clone => track.insertBefore(clone, track.firstChild));
    // clonesAfter.forEach(clone => track.appendChild(clone));

    slides = Array.from(track.children);

    let index = clonesBefore.length;
    const maxIndex = slides.length - visibleSlides;
    let slideWidth = slides[0].offsetWidth + 13;
    let isDragging = false;
    let isTransitioning = false;

    function updateSlider(animate = true) {
      track.style.transition = animate ? "transform 0.4s ease" : "none";
      track.style.transform = `translateX(-${index * slideWidth}px)`;
    }

    function handleLoop() {
      // if (isDragging || isTransitioning) return;
      // if (index >= slides.length - clonesAfter.length) {
      //   index = clonesBefore.length;
      //   track.style.transition = "none";
      //   track.style.transform = `translateX(-${index * slideWidth}px)`;
      // } else if (index < clonesBefore.length) {
      //   index = slides.length - clonesAfter.length - 1;
      //   track.style.transition = "none";
      //   track.style.transform = `translateX(-${index * slideWidth}px)`;
      // }
    }

    function goNext() {
      // if (isTransitioning) return;
      // index++;
      // isTransitioning = true;
      // updateSlider();
      if (isTransitioning) return;
  if (index >= maxIndex) return; // stop at last slide
  index++;
  isTransitioning = true;
  updateSlider();
    }

    function goPrev() {
      // if (isTransitioning) return;
      // index--;
      // isTransitioning = true;
      // updateSlider();

      if (isTransitioning) return;
  if (index <= 0) return; // stop at first slide
  index--;
  isTransitioning = true;
  updateSlider();
    }

    next.addEventListener("click", goNext);
    prev.addEventListener("click", goPrev);

    track.addEventListener("transitionend", () => {
      isTransitioning = false;
      handleLoop();
    });

    // --- Drag support ---
    let startX = 0;
    let walk = 0;

    function dragMove(x) {
      walk = x - startX;
      const maxDrag = slideWidth * 0.8;
      walk = Math.max(-maxDrag, Math.min(walk, maxDrag));
      track.style.transform = `translateX(${-index * slideWidth + walk}px)`;
    }

    function dragEnd() {
      if (!isDragging) return;
      isDragging = false;

      if (Math.abs(walk) > slideWidth / 2) {
        index += walk < 0 ? 1 : -1;
      }

      track.style.transition = "transform 0.3s ease";
      track.style.transform = `translateX(-${index * slideWidth}px)`;

      walk = 0;
      setTimeout(() => {
        handleLoop();
        isTransitioning = false;
      }, 350);
    }

    // Mouse events
    track.addEventListener("mousedown", e => {
      isDragging = true;
      startX = e.pageX;
      isTransitioning = true;
      track.style.transition = "none";
    });

    track.addEventListener("mousemove", e => {
      if (!isDragging) return;
      dragMove(e.pageX);
    });

    track.addEventListener("mouseup", dragEnd);
    track.addEventListener("mouseleave", dragEnd);

    // Touch events
    track.addEventListener("touchstart", e => {
      isDragging = true;
      startX = e.touches[0].pageX;
      isTransitioning = true;
      track.style.transition = "none";
    });

    track.addEventListener("touchmove", e => {
      if (!isDragging) return;
      dragMove(e.touches[0].pageX);
    });

    track.addEventListener("touchend", dragEnd);

    // Resize
    window.addEventListener("resize", () => {
      slideWidth = slides[0].offsetWidth + 13;
      updateSlider(false);
    });

    // Initial position
    updateSlider(false);
  });
});



// Simple and effective solution
function makeImagesClickable() {
  document.querySelectorAll('.collection-list__item').forEach(item => {
    // Get the link from h3
    const titleLink = item.querySelector('h3.card__heading a');
    const image = item.querySelector('img');
    
    if (titleLink && image) {
      const url = titleLink.href;
      
      // Create a link wrapper
      const link = document.createElement('a');
      link.href = url;
      
      link.style.textDecoration = 'none';
      link.style.color = 'inherit';
      
      // Get image parent
      const imageParent = image.parentElement;
      
      // Insert link before image
      imageParent.insertBefore(link, image);
      
      // Move image inside link
      link.appendChild(image);
      
      // Add aria-label for accessibility
      const altText = image.alt || 'Collection';
      link.setAttribute('aria-label', `Go to ${altText} collection`);
    }
  });
}

// Run the function
document.addEventListener('DOMContentLoaded', makeImagesClickable);

// Also run if content loads dynamically
if (document.readyState !== 'loading') {
  makeImagesClickable();
}